import React, { createContext, useReducer } from 'react';

import { cacheReducer } from '../redux/reducers/cacheReducer';
import { cacheActions } from '../redux/actions/cache';

import { getNestedValue } from '../utils/objectHandlers';

const CacheContext = createContext(null);

export const CacheProvider = ({ children }) => {
    const [cacheState, dispatch] = useReducer(cacheReducer, {});

    const get = (path) => getNestedValue(cacheState, path);

    const set = (path, data) => {
        console.log('info', path, data)
        dispatch(cacheActions.set(path, data));
    }

    const clear = (path) => dispatch(cacheActions.clear(path));

    const reset = () => dispatch(cacheActions.reset());

    return (
        <CacheContext.Provider value={{ cacheState, get, set, clear, reset }}>
            {children}
        </CacheContext.Provider>
    );
};

export default CacheContext;